import React, { useState, useEffect } from 'react';
import { GrLanguage } from "react-icons/gr";
import i18n from 'i18next';

const LanguageButton = ({ 
  position = { top: '10px', right: '10px' }, 
  style = {} 
}) => {
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  useEffect(() => {
    i18n.on('languageChanged', (lng) => {
      setCurrentLanguage(lng);
    });

    return () => {
      i18n.off('languageChanged');
    };
  }, []);

  const toggleLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div 
      className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded cursor-pointer hover:bg-gray-800"
      style={{ 
        minWidth: '150px', 
        position: 'absolute', 
        ...position, 
        color:'#888', 
        fontSize:'12px',
        ...style 
      }}
    >
      <GrLanguage size={15} style={{position:'absolute',
        top:'10px',
        transform: 'translateY(-50%)',
        left: '1px'}}/>
      <span 
        style={{
          cursor:'pointer', 
          fontWeight: currentLanguage === 'ko' ? 'bold' : 'normal',
          color: currentLanguage === 'ko' ? '#888' : '#adadb5',
          position:'absolute',
        top:'10px',
        transform: 'translateY(-50%)',
        left: '27px'
        }} 
        onClick={() => toggleLanguage('ko')}
      >
        한국어
      </span>
      <span style={{
        fontSize:'12px', 
        position:'absolute',
        top:'9px',
        transform: 'translateY(-50%)',
        left: '75px'
      }}>|</span>
      <span 
        style={{
          cursor:'pointer', 
          fontWeight: currentLanguage === 'en' ? 'bold' : 'normal',
          color: currentLanguage === 'en' ? '#888' : '#adadb5',
          position:'absolute',
          top:'10px',
          transform: 'translateY(-50%)',
          left: '90px'
        }} 
        onClick={() => toggleLanguage('en')}
        
      >
        English
      </span>
    </div>
  );
};

export default LanguageButton;